import variables from '../variables'

import type { SwitchOverrideToken } from './types'

const Switch: SwitchOverrideToken = {
  colorTextQuaternary: variables.gray40,
  colorTextTertiary: variables.gray60,
  colorPrimaryHover: variables.brandBlue80
} as const

export default Switch
